export enum GLOBAL_VALIDATION {
  EDIT_BASIC_INFORMATION = "EDIT_BASIC_INFORMATION",
  EDIT_EDUCATION_VALIDATION = "EDIT_EDUCATION_VALIDATION",
  ADD_LEAVE_REQ_VALIDATION = "ADD_LEAVE_REQ_VALIDATION",
  CREATE_UPDATE_RECRUITMENT_REQ = "CREATE_UPDATE_RECRUITMENT_REQ",
  RESULT_INTERVIEW = "RESULT_INTERVIEW",
}
